import { Autocomplete, Checkbox, Divider, FormControlLabel, Grid, TextField, useMediaQuery } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss';
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import dividerStyles from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import React, { useContext, useEffect, useRef, useState } from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import GlobalButton from '../../utility/globalButton/button';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import EmptyState from '../../global/emptyState';
import emptyContactListImage from "../../../assets/images/campaignContact/emptyContactListImage.png";
import IconsColor from '../../utility/iconsColor';
import GlobalPopUp from '../../utility/globalPopUp';
import AddNewListPopup from './addNewListPopup';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { archiveErrorDetail, campaignContact, campaignContactData, campaignContactTagAssignment, contactListArchiveConfirmation, contactListDeleteConfirmation, contactListDuplicateContactConfirmation, createCampaignContactFieldPayload, createCampaignContactListPayload, getCampaignContactListResponse, importCampaignContactDataPayload, tagDataInterface, tagDeleteConfirmation, updateCampaignContactFieldPyload, updateCampaignContactListPayload, updateCampaignContactPayload } from '../../../models/axiosModel';
import CreateNewContactPopup from './createNewContactPopup';
import ListCard, { contactListMenuItem } from './listCard';
import ContactList from './contactList';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { hasContactManageAccess } from '../../../utils/constants';
import { primaryColor } from '../../../utils/colors';
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import EditContactPopup from './editContactPopup';
import AddNewTagPopup from './addNewTagPopup';
import EditFieldPopup from './editFieldPopup';
import GlobalSearch from '../../utility/GlobalSearch/GlobalSearch';
import noDataFound from "../../../assets/CampaignNoDataFound.png";
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { DUPLICATE_CONTACT_TEXT, getArchiveContactListStatusId, getDuplicateContactConfirmationDescription, isArchivedContactList, isDuplicateContactAllowed, isMasterContactList } from './contactConstant';
import ArchiveIcon from '@mui/icons-material/Archive';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import agent from '../../../services/api';
import ArchiveContactErrorPopup from './archiveContactErrorPopup';

export interface flagAddTagDialogObj {
    flag: boolean,
    flagFromEditContactDialog: boolean,
    selectedTag?: tagDataInterface
}

const ContactsGlobal = () => {

    const {
        campaignContactListData,
        campaignContactData,
        setCampaignContactData,
        setFilteredCampaignContactData,
        campaignContactFieldTypeData,

        flagAddNewListDialog,
        setFlagAddNewListDialog,
        flagCreateNewContactDialog,
        setFlagCreateNewContactDialog,
        flagNewFieldDialog,
        setFlagNewFieldDialog,

        getCampaignContactListApi,
        sortContactList,
        createCampaignContactListApi,
        updateCampaignContactListApi,
        getCampaignContactApi,
        updateCampaignContactApi,
        deleteCampaignContactApi,
        importCampaignContactDataApi,
        getListOfCampaignContactFieldApi,
        createCampaignContactFieldApi,
        updateCampaignContactFieldApi,
        deleteCampaignContactFieldApi,
        getListOfCampaignFieldTypeApi,
        getListOfCampaignContactTagApi,
        deleteCampaignContactTagApi,
        getCountryCodeApi,
    } = useContext(ContactContext) as ContactContextPayload;
    const { flagLoading, setFlagLoading, userDetail, handleError, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, globalStatusData, getGlobalStatusApi } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        globalStatusData: state.listOfChatbotStatus,
        getGlobalStatusApi: state.getChatbotStatus,
    })))

    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('contact_list_id');

    const [selectedCampaignContactList, setSelectedCampaignContactList] = useState<getCampaignContactListResponse | null>(null);
    const [flagEditListDialog, setFlagEditListDialog] = useState<boolean>(false);
    const [requiredCampaignContactList, setRequiredCampaignContactList] = useState<getCampaignContactListResponse | null>(null);

    const [deleteContactString, setDeleteContactString] = useState<string>("");
    const [requiredCampaignContact, setRequiredCampaignContact] = useState<campaignContact[]>([]);

    const [filteredCampaignContactList, setFilteredCampaignContactList] = useState<getCampaignContactListResponse[] | null>(campaignContactListData);
    
    const [flagShowArchivedLists, setFlagShowArchivedLists] = useState<boolean>(false);

    const [flagShowArchiveErrorPopup, setFlagShowArchiveErrorPopup] = useState<archiveErrorDetail>({
        flagShowArchiveListError: false,
        archiveErrorDetail: null,
    })
    
    const [contactListArchiveConfirmation, setContactListArchiveConfirmation] = useState<contactListArchiveConfirmation>({
        flagShowConfirmation: false,
        selectedList: null,
    })

    const [contactListDeleteConfirmation, setContactListDeleteConfirmation] = useState<contactListDeleteConfirmation>({
        flagShowConfirmation: false,
        selectedList: null,
    })

    const [duplicateContactConfirmation, setDuplicateContactConfirmation] = useState<contactListDuplicateContactConfirmation>({
        flagShowConfirmation: false,
        selectedList: null,
    })
    
    const searchTextRef = useRef<string>("");

    const [flagEditContactDialog, setFlagEditContactDialog] = useState<boolean>(false);

    const [contactFields, setContactFields] = useState<campaignContactData[]>([]);
    const [contactTagData, setContactTagData] = useState<Omit<campaignContactTagAssignment, 'contact_tag_assignment_id'>[]>([]);
    const [flagAddTagDialogObj, setFlagAddTagDialogObj] = useState<flagAddTagDialogObj>({
        flag: false,
        flagFromEditContactDialog: false,
    })
    const [tagDeleteConfirmation, setTagDeleteConfirmation] = useState<tagDeleteConfirmation>({
        flagShowConfirmation: false,
        selectedTag: null,
    })

    const [flagOnOkayClick, setFlagOnOkayClick] = useState<boolean>(false);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const innerHeight = breakPoints.smallScreen ? (window.innerHeight - 185) : breakPoints.flagTabletScreen ? (window.innerHeight - 235) : (window.innerHeight - 178);

    const navigate = useNavigate();

    const menuItem: contactListMenuItem[] = [
        {
            type: "item",
            label: "Edit",
            icon: <EditIcon className={globalStyles.menuIcon16px} />,
            onClick: (list: getCampaignContactListResponse) => {
                handleEditList(list);
            },
            isHidden: (list: getCampaignContactListResponse) => isArchivedContactList(list, globalStatusData),
            isDisable: (list: getCampaignContactListResponse) => isMasterContactList(list?.contact_list_name),
        },
        {
            type: "item",
            label: "Archive",
            icon: <ArchiveIcon className={globalStyles.menuIcon16px} />,
            onClick: (list: getCampaignContactListResponse) => {
                setContactListArchiveConfirmation((prev) => ({
                    ...prev,
                    flagShowConfirmation: true,
                    selectedList: list,
                }))
            },
            isHidden: (list: getCampaignContactListResponse) => isArchivedContactList(list, globalStatusData),
            isDisable: (list: getCampaignContactListResponse) => isMasterContactList(list?.contact_list_name),
        },
        {
            type: "item",
            label: DUPLICATE_CONTACT_TEXT.ALLOW_LABEL,
            icon: <ControlPointDuplicateIcon className={globalStyles.menuIcon16px} />,
            onClick: (list: getCampaignContactListResponse) => {
                openDuplicateContactConfirmation(list);
            },
            isHidden: (list: getCampaignContactListResponse) => isDuplicateContactToggleHidden(list) || isDuplicateContactAllowed(list),
        },
        {
            type: "item",
            label: DUPLICATE_CONTACT_TEXT.DISALLOW_LABEL,
            icon: <ControlPointDuplicateIcon className={globalStyles.menuIcon16px} />,
            onClick: (list: getCampaignContactListResponse) => {
                openDuplicateContactConfirmation(list);
            },
            isHidden: (list: getCampaignContactListResponse) => isDuplicateContactToggleHidden(list) || !isDuplicateContactAllowed(list),
        },
        {
            type: "item",
            label: "Delete",
            icon: <DeleteIcon className={globalStyles.menuIcon16px} />,
            onClick: (list: getCampaignContactListResponse) => {
                setContactListDeleteConfirmation((prev) => ({
                    ...prev,
                    flagShowConfirmation: true,
                    selectedList: list,
                }))
            },
            isHidden: (list: getCampaignContactListResponse) => isArchivedContactList(list, globalStatusData) && (list?.total_contact > 0),
            isDisable: (list: getCampaignContactListResponse) => isMasterContactList(list?.contact_list_name) || (list?.total_contact > 0),
        }
    ]

    // Handle Archive Contact List
    const onCloseOfArchiveListPopup = () => {
        setFlagShowArchiveErrorPopup((prev) => ({
            ...prev,
            flagShowArchiveListError: false,
            archiveErrorDetail: null,
        }))
    }

    const onCloseOfArchiveConfirmationPopup = () => {
        setContactListArchiveConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: false,
            selectedList: null,
        }))
    }

    const handleArchiveList = async (list: getCampaignContactListResponse | null) => {
        onCloseOfArchiveConfirmationPopup();
        if (!list) return;

        const payload = {
            contact_list_id: list.contact_list_id,
            contact_list_status_id: getArchiveContactListStatusId(globalStatusData),
        }
        
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        
        const response = await agent.archiveContactList.put(payload);
        
        if (response.status) {
            showSuccess(`Contact list archived successfully`)
            getCampaignContactListApiCall();
        } else {
            const isUsedInWorkflowOrCampaign = response?.error?.used_in_workflow || response?.error?.used_in_campaign;
            
            if (isUsedInWorkflowOrCampaign) {
                setFlagShowArchiveErrorPopup((prev) => ({
                    ...prev,
                    flagShowArchiveListError: true,
                    archiveErrorDetail: response.error,
                }))
            } else {
                handleError(response);
            }
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    // Handle Allow / Disallow Duplicate Contacts. Not offered on the master list or archived lists, which can't be updated.
    function isDuplicateContactToggleHidden(list: getCampaignContactListResponse) {
        return isMasterContactList(list?.contact_list_name) || isArchivedContactList(list, globalStatusData);
    }

    function openDuplicateContactConfirmation(list: getCampaignContactListResponse) {
        setDuplicateContactConfirmation({
            flagShowConfirmation: true,
            selectedList: list,
        })
    }

    const onCloseOfDuplicateContactConfirmationPopup = () => {
        setDuplicateContactConfirmation({
            flagShowConfirmation: false,
            selectedList: null,
        })
    }

    const handleToggleDuplicateContact = async (list: getCampaignContactListResponse | null) => {
        onCloseOfDuplicateContactConfirmationPopup();
        if (!list || isDuplicateContactToggleHidden(list)) return;

        const flagAllowDuplicateContact = !isDuplicateContactAllowed(list);
        const payload: updateCampaignContactListPayload = {
            contact_list_id: list.contact_list_id,
            contact_list_name: list.contact_list_name,
            flag_allow_duplicate_contact: flagAllowDuplicateContact,
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await updateCampaignContactListApi(payload);
        if (response.status) {
            showSuccess(flagAllowDuplicateContact ? DUPLICATE_CONTACT_TEXT.ALLOW_SUCCESS : DUPLICATE_CONTACT_TEXT.DISALLOW_SUCCESS)
            getCampaignContactListApiCall();
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    // Handle Delete Contact List
    const onCloseOfDeleteListPopup = () => {
        setContactListDeleteConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: false,
            selectedList: null,
        }))
    }

    const handleDeleteList = async (list: getCampaignContactListResponse | null) => {
        onCloseOfDeleteListPopup();
        if (!list) return;

        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await agent.deleteContactList.delete(list.contact_list_id);
        if (response.status) {
            showSuccess(`Contact list deleted successfully`)
            getCampaignContactListApiCall();
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleEditList = (list: getCampaignContactListResponse) => {
        setRequiredCampaignContactList(list);
        setFlagEditListDialog(true);
    }

    const handleAddNewList = () => {
        setFlagAddNewListDialog(true);
    }

    const handleAddNewContact = () => {
        setFlagCreateNewContactDialog(true);
    }

    const createCampaignContactListApiCall = async (payload: createCampaignContactListPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await createCampaignContactListApi(payload);
        if (response.status && response.data) {
            showSuccess(`List Created Successfully`)

            getCampaignContactListApiCall();
            setSearchParams({ 'contact_list_id': response.data[0]?.contact_list_id.toString() });
        }
        if (!(response.status)) {
            handleError(response);
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleAddNewListSaveButtonClick = (name: string) => {
        const payload = {
            contact_list_name: name,
        }
        createCampaignContactListApiCall(payload);
    }

    const updateCampaignContactListApiCall = async (payload: updateCampaignContactListPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await updateCampaignContactListApi(payload);
        if (response.status) {
            showSuccess(`List Updated Successfully`)
            getCampaignContactListApiCall();
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleUpdateListSaveButtonClick = (name: string, id?: number) => {
        if (id == undefined) {
            console.error("ID is required but missing!!");
            return;
        }
        const payload = {
            contact_list_id: id,
            contact_list_name: name,
        }

        updateCampaignContactListApiCall(payload);
        setFlagEditListDialog(false);
    }

    const getCampaignContactListApiCall = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await getCampaignContactListApi();
        if (!(response.status)) {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const getCampaignContactApiCall = async (list_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const payload = {
            contact_list_id: list_id,
        }
        const response: any = await getCampaignContactApi(payload);
        if (!response.status) {

            handleError(response);
            navigate('/contacts')
        } else {
            const currentList = response.data.find((list: getCampaignContactListResponse) => list.contact_list_id === Number(list_id));
            if (currentList) {
                setSelectedCampaignContactList(currentList);
            }
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const getListOfCampaignContactTagApiCall = async (list_id: number) => {
        // setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await getListOfCampaignContactTagApi(list_id);
        if (!(response.status)) {
            handleError(response);
            navigate('/contacts')
        }
        // setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const getListOfCampaignFieldTypeApiCall = async () => {
        const response = await getListOfCampaignFieldTypeApi();
        if (!(response.status)) {
            handleError(response);
            navigate('/contacts')
        }
    }

    const getListOfCampaignContactFieldApiCall = async (list_id: number) => {
        // setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        // const list_id = selectedCampaignContactList?.contact_list_id as Number;
        const response = await getListOfCampaignContactFieldApi(list_id);
        if (!(response.status)) {
            handleError(response);
        }

        // setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const createCampaignContactFieldApiCall = async (payload: createCampaignContactFieldPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        if (campaignContactFieldTypeData.length === 0) {
            await getListOfCampaignFieldTypeApiCall();
        }
        const response = await createCampaignContactFieldApi(payload);
        if (!(response.status)) {
            handleError(response);
        } else {
            showSuccess(`Field Created Successfully`)
            await getListOfCampaignContactFieldApiCall(Number(list_id));
            await getCampaignContactApiCall(Number(list_id));
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const updateCampaignContactFieldApiCall = async (payload: updateCampaignContactFieldPyload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const list_id = selectedCampaignContactList?.contact_list_id as number;
        if (campaignContactFieldTypeData.length === 0) {
            await getListOfCampaignFieldTypeApiCall();
        }
        const response = await updateCampaignContactFieldApi(payload);
        if (!(response.status)) {
            handleError(response);
        } else {
            showSuccess(`Field Updated Successfully`)
            await getListOfCampaignContactFieldApiCall(list_id);
            await getCampaignContactApiCall(list_id);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const deleteCampaignContactFieldApiCall = async (contact_field_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const list_id = selectedCampaignContactList?.contact_list_id as number;
        if (campaignContactFieldTypeData.length === 0) {
            await getListOfCampaignFieldTypeApiCall();
        }
         const response = await deleteCampaignContactFieldApi(contact_field_id);
        if (!(response.status)) {
            handleError(response);
        } else {
            showSuccess(`Field Deleted Successfully`)
            await getListOfCampaignContactFieldApiCall(list_id);
            await getCampaignContactApiCall(list_id);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const getSuccessMessageForImportContact = (uploaded_contacts: number, remaning_contacts: number) => {
        // Duplicate-enabled lists only skip rows with an invalid phone number or no first name
        if (isDuplicateContactAllowed(selectedCampaignContactList)) {
            if (uploaded_contacts == 0) {
                return DUPLICATE_CONTACT_TEXT.IMPORT_NONE;
            }
            return remaning_contacts != 0
                ? `${uploaded_contacts} contacts have been successfully imported to your list and ${remaning_contacts} contacts were skipped because of an invalid phone number or a missing first name.`
                : `${uploaded_contacts} contacts have been successfully imported to your list.`
        }
        if(uploaded_contacts == 0){
            return "All the imported contacts are already in your list. No new contacts were imported.";
        } else if(remaning_contacts != 0){
            return `${uploaded_contacts} new contacts have been successfully imported to your list and ${remaning_contacts} contacts are already in your list.`
        } else {
            return `${uploaded_contacts} new contacts have been successfully imported to your list.`
        }
    }

    const importCampaignContactDataApiCall = async (payload: importCampaignContactDataPayload) => {
        const response = await importCampaignContactDataApi(payload);
        setFlagCreateNewContactDialog(false);
        if (response.status) {
            const id = selectedCampaignContactList?.contact_list_id;
            if (id) {
                getCampaignContactApiCall(id);
            }
            showSuccess(getSuccessMessageForImportContact(response.uploaded_contacts, response.remaning_contacts))
        } else {
            handleError(response);
        }
        setFlagOnOkayClick(false);
    }

    const handleListChange = (e: React.ChangeEvent<{}>, value: getCampaignContactListResponse) => {
        setSearchParams({ 'contact_list_id': (value.contact_list_id).toString() });
        // Get Campaign Contact Call  
        // setCampaignContactData([]);
        setCampaignContactData(null);
        // setFilteredCampaignContactData([]);
        setFilteredCampaignContactData(null);
        getCampaignContactApiCall(value.contact_list_id);
        getListOfCampaignContactTagApiCall(value.contact_list_id);
        getListOfCampaignContactFieldApiCall(value.contact_list_id);
    }

    const onClickHandler = (contact_list_id: number) => {
        setSearchParams({ 'contact_list_id': (contact_list_id).toString() });
        navigate('/contacts?contact_list_id=' + contact_list_id)

    }

    const deleteContactApiCall = async (contacts: campaignContact[]) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const contact_ids: number[] = contacts.map(contact => {
            return contact.contact_id
        });
        const response = await deleteCampaignContactApi({ contact_id: contact_ids });
        if (response.status) {
            showSuccess(`Contact Deleted Successfully`)

            const list_id = selectedCampaignContactList?.contact_list_id;
            if (list_id) {
                getCampaignContactApiCall(list_id);
            }
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });

        // Close the poppup
        setDeleteContactString("");
        setRequiredCampaignContact([]);
    }

    const deleteCampaignContact = (contacts: campaignContact[]) => {
        setRequiredCampaignContact(contacts);
        if (contacts.length === 1) {
            setDeleteContactString(`this contact "${contacts[0].contact_phone_number}"`);
        } else {
            setDeleteContactString("all selected contacts");
        }
    }

    const editCampaignContact = (contacts: campaignContact[]) => {
        setRequiredCampaignContact(contacts);
        setFlagEditContactDialog(true);
    }

    const manageListClickHandler = () => {
        navigate("/contacts");
        setSelectedCampaignContactList(null);
        // setCampaignContactData([]);
        setCampaignContactData(null);
        // setFilteredCampaignContactData([]);
        setFilteredCampaignContactData(null);
    }

    const editCampaignContactApiCall = async (payload: updateCampaignContactPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const res = await updateCampaignContactApi(payload);
        if (res.status) {
            showSuccess(`Contact Updated Successfully`)
            const id = selectedCampaignContactList?.contact_list_id;
            if (id) {
                getCampaignContactApiCall(id);
            }
        } else {
            handleError(res);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const applyContactListFilter = (query: string, showArchived: boolean) => {
        if (!campaignContactListData) {
            return;
        }

        const archivedStatusId = getArchiveContactListStatusId(globalStatusData);
        
        const filter_data = campaignContactListData.filter((list: getCampaignContactListResponse) => {
            const matchesSearch = !query || (list.contact_list_name != null && list.contact_list_name.toLowerCase().includes(query));
            if (!matchesSearch) {
                return false;
            }
            // When checkbox is checked, include archived lists in search results too
            if (showArchived) {
                return true;
            }
            return archivedStatusId == null || list.contact_list_status_id != archivedStatusId;
        });

        setFilteredCampaignContactList(filter_data);
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e?.target?.value?.toLowerCase() ?? "";
        searchTextRef.current = query;
        applyContactListFilter(query, flagShowArchivedLists);
    }

    const handleToggleShowArchivedLists = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setFlagShowArchivedLists(checked);
        applyContactListFilter(searchTextRef.current, checked);
    }

    const handleCloseTagDialog = () => {
        if (flagAddTagDialogObj.flagFromEditContactDialog) {
            setFlagEditContactDialog(true);
        }
        setFlagAddTagDialogObj((prev) => ({
            flag: false,
            flagFromEditContactDialog: false,
            selectedTag: prev?.selectedTag
        }));
    }

    const getCountryCodeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getCountryCodeApi();
        if(!(res.status)){
            handleError(res);   
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getGlobalStatusApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getGlobalStatusApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        const getInitialData = async () => {
            const campaignContactListId = Number(searchParams.get('contact_list_id'));
            if (campaignContactListId) {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
                if (!campaignContactListData) {
                    getCampaignContactListApiCall();
                } else {
                    getListOfCampaignContactTagApiCall(campaignContactListId);
                    getListOfCampaignContactFieldApiCall(campaignContactListId);
                    getCampaignContactApiCall(campaignContactListId);
                }
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

            } else {
                navigate("/contacts");
                setSelectedCampaignContactList(null);
                setCampaignContactData(null)

                await Promise.all([
                    getCampaignContactListApiCall(),
                    ...(!globalStatusData ? [getGlobalStatusApiCall()] : []),
                ])
            }
        }
        getInitialData();
    }, [searchParams])

    useEffect(() => {
        if (campaignContactListData) {
            applyContactListFilter(searchTextRef.current, flagShowArchivedLists);
        } else {
            setFilteredCampaignContactList(null);
        }

        if (campaignContactListData && campaignContactListData.length > 0) {
            const campaignContactListId = searchParams.get('contact_list_id');
            if (campaignContactListId && campaignContactListId.length > 0) {
                const currentList = campaignContactListData.find((list: getCampaignContactListResponse) => list.contact_list_id === Number(campaignContactListId));
                if (currentList) {
                    setSelectedCampaignContactList(currentList);
                    // Get Campaign Contact Call 
                    getCampaignContactApiCall(currentList.contact_list_id);
                    // Get Campaign Tag Call 
                    getListOfCampaignContactTagApiCall(currentList.contact_list_id);
                    getListOfCampaignContactFieldApiCall(currentList.contact_list_id);
                } else {
                    navigate("/contacts");
                }
            }
        }
    }, [campaignContactListData])

    useEffect(() => {
        if (requiredCampaignContact.length > 0 && requiredCampaignContact[0].contact_data && requiredCampaignContact[0].contact_data.length > 0) {
            let data = JSON.parse(JSON.stringify(requiredCampaignContact[0].contact_data))
            setContactFields(data);
            setContactTagData(requiredCampaignContact[0].contact_tag_assignment);
        }
    }, [requiredCampaignContact])

    const onClickOfCustomTagOption = (flagEditTagPopup: boolean, flagEditTag: boolean, tag?: tagDataInterface) => {
        if(flagEditTagPopup){
            setFlagEditContactDialog(false);
        }
        setFlagAddTagDialogObj((prev: flagAddTagDialogObj) => ({ 
            flag: true, 
            flagFromEditContactDialog: flagEditTagPopup ? true : false,
            ...(flagEditTag && {
                selectedTag: tag
            })
        }))
    }

    const onClickOfDeleteTag = (tag: tagDataInterface) => {
        setTagDeleteConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: true,
            selectedTag: tag,
        }))
    }

    const onCloseOfDeleteTagPopup = () => {
        setTagDeleteConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: false,
            selectedTag: null,
        }))
    }

    const deleteContactTagApiCall = async (contactTagId?: number) => {
        if(contactTagId){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await deleteCampaignContactTagApi(contactTagId);
            if(!(res.status)){
                handleError(res);
            } else {
                const id = selectedCampaignContactList?.contact_list_id;
                if (id) getListOfCampaignContactTagApiCall(id);
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
        onCloseOfDeleteTagPopup();
    }

    const isContactListArchived = (list: getCampaignContactListResponse | null) => {
        return isArchivedContactList(list, globalStatusData);
    }

    return (
        <>
            <GlobalPopUp
                open={flagAddNewListDialog}
                onClose={() => { setFlagAddNewListDialog(false) }}
                handleClose={() => { setFlagAddNewListDialog(false) }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <AddNewListPopup
                    handleAddNewListSaveButtonClick={handleAddNewListSaveButtonClick}
                    flagEditList={false}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagCreateNewContactDialog}
                onClose={() => { setFlagCreateNewContactDialog(false) }}
                handleClose={() => { setFlagCreateNewContactDialog(false) }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                borderRadius='10px'
                titlePadding='0px'
                margin={breakPoints.smallScreen ? "15px" : "32px"}
            >
                <CreateNewContactPopup
                    selectedCampaignContactList={selectedCampaignContactList as getCampaignContactListResponse}
                    importCampaignContactDataApiCall={importCampaignContactDataApiCall}
                    setFlagOnOkayClick={setFlagOnOkayClick}
                    getListOfCampaignFieldTypeApiCall={getListOfCampaignFieldTypeApiCall}
                    getListOfCampaignContactFieldApiCall={getListOfCampaignContactFieldApiCall}
                    createCampaignContactFieldApiCall={createCampaignContactFieldApiCall}
                    updateCampaignContactFieldApiCall={updateCampaignContactFieldApiCall}
                    deleteCampaignContactFieldApiCall={deleteCampaignContactFieldApiCall}

                    setFlagAddTagDialogObj={setFlagAddTagDialogObj}
                    getCampaignContactApiCall={getCampaignContactApiCall}
                    getCountryCodeApiCall={getCountryCodeApiCall}
                    onClickOfCustomTagOption={onClickOfCustomTagOption}
                    onClickOfDeleteTag={onClickOfDeleteTag}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagEditListDialog}
                onClose={() => { setFlagEditListDialog(false); setRequiredCampaignContactList(null); }}
                handleClose={() => { setFlagEditListDialog(false); setRequiredCampaignContactList(null); }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "350px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "650px" : "650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <AddNewListPopup
                    handleAddNewListSaveButtonClick={handleUpdateListSaveButtonClick}
                    flagEditList={true}
                    requiredList={requiredCampaignContactList}
                    setFlagEditListDialog={setFlagEditListDialog}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagEditContactDialog}
                onClose={() => { setFlagEditContactDialog(false); }}
                handleClose={() => { setFlagEditContactDialog(false); }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <EditContactPopup
                    requiredCampaignContact={requiredCampaignContact}
                    setFlagEditContactDialog={setFlagEditContactDialog}
                    editCampaignContactApiCall={editCampaignContactApiCall}
                    getCountryCodeApiCall={getCountryCodeApiCall}
                    onClickOfCustomTagOption={onClickOfCustomTagOption}
                    onClickOfDeleteTag={onClickOfDeleteTag}

                    contactFields={contactFields}
                    setContactFields={setContactFields}
                    contactTagData={contactTagData}
                    setContactTagData={setContactTagData}
                    flagAddTagDialogObj={flagAddTagDialogObj}
                    setFlagAddTagDialogObj={setFlagAddTagDialogObj}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagAddTagDialogObj.flag}
                handleClose={() => handleCloseTagDialog()}
                onClose={() => handleCloseTagDialog()}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <AddNewTagPopup
                    flagAddTagDialogObj={flagAddTagDialogObj}
                    setFlagAddTagDialogObj={setFlagAddTagDialogObj}

                    setFlagEditContactDialog={setFlagEditContactDialog}
                    flagEditTag={flagAddTagDialogObj.selectedTag ? true : false}
                    getListOfCampaignContactTagApiCall={getListOfCampaignContactTagApiCall}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagNewFieldDialog}
                onClose={() => setFlagNewFieldDialog(false)}
                handleClose={() => setFlagNewFieldDialog(false)}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <EditFieldPopup
                    setFlagNewFieldDialog={setFlagNewFieldDialog}
                    createCampaignContactFieldApiCall={createCampaignContactFieldApiCall}
                    getListOfCampaignFieldTypeApiCall={getListOfCampaignFieldTypeApiCall}
                    flagEdit={false}
                />
            </GlobalPopUp>

            {deleteContactString.length > 0 &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${deleteContactString}`}
                    open={deleteContactString.length > 0}
                    onClose={() => { setDeleteContactString(""); setRequiredCampaignContact([]); }}
                    onDelete={() => { deleteContactApiCall(requiredCampaignContact); }}
                />
            }

            {tagDeleteConfirmation?.flagShowConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${tagDeleteConfirmation?.selectedTag?.contact_tag_name} tag`}
                    open={tagDeleteConfirmation?.flagShowConfirmation}
                    onClose={() => onCloseOfDeleteTagPopup()}
                    onDelete={() => deleteContactTagApiCall(tagDeleteConfirmation?.selectedTag?.contact_tag_id)}
                />
            }

            {/* Archive Contact List */}
            {flagShowArchiveErrorPopup.flagShowArchiveListError &&
                <GlobalPopUp
                    open={flagShowArchiveErrorPopup.flagShowArchiveListError}
                    onClose={() => onCloseOfArchiveListPopup()}
                    handleClose={() => onCloseOfArchiveListPopup()}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <ArchiveContactErrorPopup errorDetails={flagShowArchiveErrorPopup.archiveErrorDetail} />
                </GlobalPopUp>
            }

            {contactListArchiveConfirmation?.flagShowConfirmation &&
                <GlobalDeletePopup
                    title="Archive Confirmation"
                    primaryButtonText="Archive"
                    icon={<ArchiveIcon className={contactStyles.archiveConfirmationIcon} />}
                    deleteDescription={`Are you sure you want to archive "${contactListArchiveConfirmation?.selectedList?.contact_list_name}" list`}
                    open={contactListArchiveConfirmation?.flagShowConfirmation}
                    onClose={() => onCloseOfArchiveConfirmationPopup()}
                    onDelete={() => handleArchiveList(contactListArchiveConfirmation?.selectedList)}
                />
            }

            {/* Allow / Disallow Duplicate Contacts */}
            {duplicateContactConfirmation?.flagShowConfirmation &&
                <GlobalDeletePopup
                    title={isDuplicateContactAllowed(duplicateContactConfirmation?.selectedList) ? DUPLICATE_CONTACT_TEXT.DISALLOW_LABEL : DUPLICATE_CONTACT_TEXT.ALLOW_LABEL}
                    primaryButtonText={isDuplicateContactAllowed(duplicateContactConfirmation?.selectedList) ? DUPLICATE_CONTACT_TEXT.DISALLOW_BUTTON : DUPLICATE_CONTACT_TEXT.ALLOW_BUTTON}
                    icon={<ControlPointDuplicateIcon className={contactStyles.archiveConfirmationIcon} />}
                    deleteDescription={getDuplicateContactConfirmationDescription(duplicateContactConfirmation?.selectedList)}
                    deleteNote={isDuplicateContactAllowed(duplicateContactConfirmation?.selectedList) ? DUPLICATE_CONTACT_TEXT.DISALLOW_NOTE : DUPLICATE_CONTACT_TEXT.ALLOW_NOTE}
                    open={duplicateContactConfirmation?.flagShowConfirmation}
                    onClose={() => onCloseOfDuplicateContactConfirmationPopup()}
                    onDelete={() => handleToggleDuplicateContact(duplicateContactConfirmation?.selectedList)}
                />
            }

            {/* Delete Contact List */}
            {contactListDeleteConfirmation?.flagShowConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete "${contactListDeleteConfirmation?.selectedList?.contact_list_name}" list`}
                    open={contactListDeleteConfirmation?.flagShowConfirmation}
                    onClose={() => onCloseOfDeleteListPopup()}
                    onDelete={() => handleDeleteList(contactListDeleteConfirmation?.selectedList)}
                />
            }

            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid
                    container
                    className={`${contactStyles.contactPageHeaderContainer} ${(campaignContactListData && campaignContactListData.length === 0) ? contactStyles.contactPageHeaderContainerEmpty : ""}`}
                    direction={"column"}
                    flexWrap={"nowrap"}
                >
                    <Grid item xs={12} sm={12}>
                        <Grid container className={globalStyles.alignItemCenter} direction={"column"}>
                            <Grid
                                item
                                className={`${contactStyles.fullwidth} ${contactStyles.contactPageHeaderInner} ${(campaignContactListData && campaignContactListData.length === 0) ? contactStyles.contactPageHeaderInnerEmpty : ""}`}
                            >
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        (campaignContactListData && campaignContactListData.length === 0) ?
                                            "Contacts"
                                            :
                                            selectedCampaignContactList && campaignContactListData ?
                                                <Grid item xs={9} lg={6}>
                                                    <Grid container gap={"12px"} alignItems={"center"} flexWrap={"nowrap"}>
                                                        <Grid item className={globalStyles.displayFlexStyle}>
                                                            <KeyboardBackspaceIcon
                                                                onClick={() => manageListClickHandler()}
                                                                className={contactStyles.contactListBackIcon}
                                                            />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Autocomplete
                                                                disableClearable
                                                                value={campaignContactListData.find((list) => Number(selectedCampaignContactList.contact_list_id) == list.contact_list_id)}
                                                                className={`${styles.chatbotTitleSelect} ${globalStyles.globalHeaderFontSize} ${globalStyles.globalHeaderFontWeight}`}
                                                                options={campaignContactListData}
                                                                getOptionLabel={(option: getCampaignContactListResponse) => option.contact_list_name}
                                                                onChange={(e, value) => handleListChange(e, value)}
                                                                renderInput={(params) => <TextField {...params} placeholder='Select' />}
                                                                ListboxProps={{
                                                                    className: contactStyles.contactListAutoCompleteListBox,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                :
                                                "List"
                                    }
                                    flagMainTextOnly
                                    actionBlock={
                                        (!(breakPoints.smallScreen)) &&
                                        // campaignContactListData && campaignContactListData.length > 0 &&
                                        <Grid container gap={2} justifyContent={breakPoints.flagTabletScreen ? "start" : "end"} flexWrap={"nowrap"}>
                                            {/* {selectedCampaignContactList && */}
                                            {searchParams.get('contact_list_id') &&
                                                <>
                                                    {hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isContactListArchived(selectedCampaignContactList) && 
                                                        <Grid item>
                                                            <GlobalButton
                                                                className='borderedButtonStyle'
                                                                buttonText={breakPoints.flagSmallScreen ? "Field" : "New Field"}
                                                                startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor={primaryColor} />}
                                                                sx={{ width: breakPoints.flagSmallScreen ? "100px" : "150px" }}
                                                                onClick={() => setFlagNewFieldDialog(true)}
                                                                disabled={isContactListArchived(selectedCampaignContactList)}
                                                            />
                                                        </Grid>
                                                    }
                                                </>
                                            }
                                            {hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                <Grid item>
                                                    <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} gap="15px" justifyContent={{ lg: "end" }}>
                                                        <Grid item>
                                                            {!searchParams.get('contact_list_id') ?
                                                                <GlobalButton
                                                                    className='primaryButtonStyle'
                                                                    buttonText={"New List"}
                                                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                                    sx={{ width: "150px" }}
                                                                    onClick={() => { handleAddNewList(); }}
                                                                />
                                                                :
                                                                (campaignContactData && campaignContactData.length > 0) && !isContactListArchived(selectedCampaignContactList) &&
                                                                <GlobalButton
                                                                    className='primaryButtonStyle'
                                                                    buttonText={breakPoints.flagSmallScreen ? "Contact" : "New Contact"}
                                                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                                    sx={{ width: breakPoints.flagSmallScreen ? "100px" : "150px" }}
                                                                    onClick={() => { handleAddNewContact(); }}
                                                                    disabled={isContactListArchived(selectedCampaignContactList)}
                                                                />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Grid>

                                    }
                                />
                                {!(breakPoints.smallScreen) && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${dividerStyles.customAPIPageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} className={contactStyles.contactPageBody}>

                        {campaignContactListData && campaignContactListData.length === 0 ?
                            <Grid item className={globalStyles.fullwidth}>
                                <EmptyState
                                    height={breakPoints.flagTabletScreen ? 'calc(100vh - 150px)' : 'calc(100vh - 125px)'}
                                    pageIcon={<img alt="chatbot" src={emptyContactListImage} style={{ width: "165px", height: "auto" }} />}
                                    pageSubText={"No List Generated Yet"}
                                    primaryActionBtn={<GlobalButton
                                        buttonText={"New List"}
                                        className='primaryButtonStyle'
                                        sx={{ width: "150px" }}
                                        startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                        onClick={() => { handleAddNewList() }}
                                    />}
                                />
                            </Grid>
                            :
                            (!searchParams.get('contact_list_id')) ?
                                <>
                                    <Grid item className={globalStyles.fullwidth}>
                                        <Grid container className={contactStyles.contactListSearchRow}>
                                            <Grid item className={`${globalStyles.globalSearchbarSubItem}`}>
                                                <GlobalSearch
                                                    fullWidth
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                                    size="small"
                                                    placeholder="Search Contact List"
                                                    className={contactStyles.searchbar}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            className={globalStyles.primaryCheckbox}
                                                            checked={flagShowArchivedLists}
                                                            onChange={handleToggleShowArchivedLists}
                                                            size="small"
                                                        />
                                                    }
                                                    label="Show Archived List"
                                                    className={contactStyles.showArchivedLabel}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {!filteredCampaignContactList ?
                                        <></> :
                                        filteredCampaignContactList.length > 0 ?
                                            <Grid container gap={"18px"} className={contactStyles.contactCardPageBody} sx={{ maxHeight: `${innerHeight}px !important` }}>
                                                {sortContactList(filteredCampaignContactList).map((list, ind) => {
                                                    return (
                                                        <Grid item key={ind}>
                                                            <ListCard list={list} onClickHandler={onClickHandler} menuItem={menuItem} />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            :
                                            <Grid item xs={12} className={contactStyles.noDataFoundItem}>
                                                <EmptyState
                                                    height={'calc(100vh - 250px) !important'}
                                                    pageIcon={<img alt="chatbot" src={noDataFound} />}
                                                    pageText={"No Data Found!"}
                                                />
                                            </Grid>
                                    }
                                </>
                                :
                                (!campaignContactData ?
                                    <></> :

                                    (campaignContactData.length > 0 || flagOnOkayClick) ?
                                        <>
                                            <ContactList
                                                deleteCampaignContact={deleteCampaignContact}
                                                editCampaignContact={editCampaignContact}
                                                selectedCampaignContactList={selectedCampaignContactList as getCampaignContactListResponse}
                                                getCampaignContactApiCall={getCampaignContactApiCall}
                                                updateCampaignContactFieldApiCall={updateCampaignContactFieldApiCall}
                                                getListOfCampaignFieldTypeApiCall={getListOfCampaignFieldTypeApiCall}
                                                deleteCampaignContactFieldApiCall={deleteCampaignContactFieldApiCall}
                                                setFlagAddTagDialogObj={setFlagAddTagDialogObj}
                                            />
                                        </>
                                        :
                                        <Grid item className={globalStyles.fullwidth}>
                                            <EmptyState
                                                height={breakPoints.flagTabletScreen ? 'calc(100vh - 150px)' : 'calc(100vh - 125px)'}
                                                pageIcon={<img alt="chatbot" src={emptyContactListImage} style={{ width: "165px", height: "auto" }} />}
                                                pageSubText={isContactListArchived(selectedCampaignContactList) ? "This list is archived. No actions can be performed." : "No Contact Generated Yet"}
                                                primaryActionBtn={isContactListArchived(selectedCampaignContactList) ? <></> : <GlobalButton
                                                    buttonText={"New Contact"}
                                                    className='primaryButtonStyle'
                                                    sx={{ width: "150px" }}
                                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                    onClick={() => { handleAddNewContact() }}
                                                    disabled={isContactListArchived(selectedCampaignContactList)}
                                                />}
                                            />
                                        </Grid>
                                )
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ContactsGlobal
